import { IInternalNotification, NotificationMessageType, NotificationType } from 'types/internalNotifications';

export const InAppNotificationItems: Record<NotificationMessageType, IInternalNotification> = {
  [NotificationMessageType.NO_INTERNET]: {
    priority: 1,
    isInApp: true,
    id: NotificationMessageType.NO_INTERNET,
    msg: NotificationMessageType.NO_INTERNET,
    msg_type: NotificationType.NOT_CLOSABLE,
  },

  [NotificationMessageType.EXTERNAL_RESOURCES_FAILED]: {
    priority: 2,
    isInApp: true,
    id: NotificationMessageType.EXTERNAL_RESOURCES_FAILED,
    msg: NotificationMessageType.EXTERNAL_RESOURCES_FAILED,
    msg_type: NotificationType.NOT_CLOSABLE,
  },
};
